import { render, staticRenderFns } from "./companyCard.vue?vue&type=template&id=90daf94c&scoped=true"
import script from "./companyCard.vue?vue&type=script&lang=js"
export * from "./companyCard.vue?vue&type=script&lang=js"
import style0 from "./companyCard.vue?vue&type=style&index=0&id=90daf94c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90daf94c",
  null
  
)

export default component.exports